export const data = {
  personal_info: {
    first_name: "Chirag",
    last_name: "Berde",
    email: "chirag.berde@gmail.com",
    mobile: "+919986954030",
    address: "55, Mumbai ",
    city: " Mumbai",
    state: "Maharastra",
    postal_code: "400705",
    objective:
      "Front-End Developer with experience in React.js, Redux, and REST APIs, as well as a working knowledge of Node.js, a popular back-end language. I am passionate about creating dynamic, interactive web applications that provide an engaging user experience.",
  },
  work_experience: [
    {
      id: 1,
      job_title: "Web 2 & Web 3 Developer",
      organization_name: "Alma Better",
      start_year: "2022",
      end_year: "present",
    },
    {
      id: 2,
      job_title: "Web 2 & Web 3 Developer",
      organization_name: "Alma Better",
      start_year: "2022",
      end_year: "present",
    },
  ],
  education_details: {
    type: "Graduation",
    university: "Mumbai",
    degree: "BSC IT",
    start_year: "2019",
    end_year: "2022",
  },
  key_skills: ["ReactJs", "Javascript", "Node Js", "Redux"],
};
